import { promoService } from '@/services/promo'

const state = {
  promoCode: null,
  codeData: {},
}


const actions = {
  getCode({ commit }, payload) {
    let promoCode = localStorage.getItem('promoCode')
    promoService.getCode(promoCode)
      .then(
        codeData => {
          commit('setCode', promoCode)
          commit('setCodeData', codeData)

        },
        error => {
          console.error(error)
          commit('clearCode')
        }
      )

  }
}

const mutations = {
  setCode(state, code) {
    state.promoCode = code
  },
  setCodeData(state, data) {
    state.codeData = data
  },
  clearCode(state) {
    state.promoCode = null
    state.codeData = {}
    // localStorage.removeItem('promoCode') maybe but what if we ad more stock u know
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  state
}